import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import style from './style.css'

export default function MidActivityModal (props) {
  return (
    <div>
      <Modal show={true} className={classnames(style.modalContainer)} data-test-id="midWayModall">
        <div className={style.contentWrapper} tabIndex="0">
          <Modal.Header className={classnames('modal-header', style.headerContainer)}>
            <Modal.Title className={style.modalTitle}>You're halfway done!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className={style.content}>
              Now is a good time to visit your personalized study plan to see how you're doing on each of
              the topics covered in the activity.
            </p>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <button
              className={classnames('btn-cdl-main', style.toStudyPlan)}
              onClick={() => props.onClick('studyPlan')}
              data-test-id="midWayModalStudyPlanBtn"
            >
              View study plan
            </button>
            <button
              className={classnames('btn-cdl-secondary', style.nextQuestion)}
              onClick={() => props.onClick('nextItem')}
              data-test-id="midWayModalNextQuestionBtn"
            >
              Go to next question
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  )
}

MidActivityModal.propTypes = {
  onClick: PropTypes.func.isRequired
}
